module.exports = "https://www.gc-qa.gnp.com.mx/afcbf86dcd9843093f678bdb41d6b412.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pago-linea.png
// module id = 8157
// module chunks = 0